/* eslint-disable @gandi/gandi/no-global-element */
// @flow
import * as React from 'react';

import { Base, Svg } from '@gandi/ui';

import useDebounce from '../../../helpers/use-debounce';
import styles from './SearchInput.scss';

type Props = {|
  query: string,
  placeholder: string,
  onChange: (evt: SyntheticInputEvent<>) => void,
  onFocus: () => void,
  onSearch: (value: string) => void,
  onSelectSuggestion: () => void,
  onSelectNextSuggestion: () => void,
  onSelectPrevSuggestion: () => void,
  inputProps?: { ... },
|};

function SearchInput({
  query,
  placeholder,
  onChange,
  onFocus,
  onSearch,
  onSelectSuggestion,
  onSelectNextSuggestion,
  onSelectPrevSuggestion,
  inputProps,
}: Props): React.Element<typeof Base> {
  const debouncedSearchTerm = useDebounce(query, 500);

  React.useEffect(
    () => onSearch(debouncedSearchTerm),
    [debouncedSearchTerm, onSearch]
  );

  function handleKeyDown(evt: SyntheticKeyboardEvent<>) {
    switch (evt.key) {
      case 'Enter':
        evt.preventDefault();
        onSelectSuggestion();
        break;

      case 'ArrowUp':
        evt.preventDefault();
        onSelectPrevSuggestion();
        break;

      case 'ArrowDown':
        evt.preventDefault();
        onSelectNextSuggestion();
        break;

      default:
      // Pass
    }
  }

  return (
    <Base
      flex
      flexRow
      flexAlignItemsCenter
      flexJustifyCenter
      padding="xsmall"
      backgroundColor="white"
      className={styles.root}
    >
      <Svg theme="green" name="magnifying" className={styles.icon} />

      <Base flex flexGrow1 className={styles.inputWrapper}>
        <input
          {...inputProps}
          type="search"
          name="documentation-search"
          placeholder={placeholder}
          value={query}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          autoComplete="off"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          className={styles.input}
        />
      </Base>
    </Base>
  );
}

export default SearchInput;
